import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  card: {
    width: 100,
    height: 200
  }
})

const DriftPlaceholder = props => {
  const { classes } = props

  return <div className={classes.card} />
}

export default withStyles(styles)(DriftPlaceholder)



// WEBPACK FOOTER //
// ./src/components/DriftPlaceholder.js